import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/css";
import RequestDetails from "./RequestDetails";
import {useDebounce} from "@uidotdev/usehooks";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    showServerErrorMessage,
    convertUniversalDateToPersianDate,
    RaikoGridOneColumn,
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoCollapsibleTable,
    createCollapsedTableRowData,
    RaikoTableTitleContainer, RaikoTableSearchContainer, RaikoDatePicker,
} from "@moeindal/base-raiko-panel-components";
import {
    getHabitationRequestStatus,
    HabitationOrderTypes,
    HabitationRequestStatusTypes
} from "../periodList/periodDetails/HabitationRequestStatusTypes";
import {useLocation} from "react-router-dom";
import TableOtherAccessContainer
    from "../../component/tableCreateHelper/tableOtherAccessContainer/TableOtherAccessContainer";
import excel from "../../assets/images/icons/ic-excel-48.svg"
import {HttpClient} from "../../service/httpClient/HttpClient";
import {doDownloadFile} from "../../util/DownloadHelper";

const RequestsList = ({periodId}) => {

    let page = 0
    const size = 15
    const location = useLocation();

    const currentPath = location.pathname;
    const currentSearch = location.search;

    const prevPath = useRef(currentPath + currentSearch);

    useEffect(() => {
        const current = currentPath + currentSearch;
        if (current !== prevPath.current) {
            console.log("currentPath:", currentPath);
            console.log("currentSearch:", currentSearch);
            prevPath.current = current;
        }
    }, [location]);

    const [totalItems, setTotalItems] = useState(0);

    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [startDate, setStartDate] = useState("");

    const [status, setStatus] = useState(HabitationRequestStatusTypes.ALL.id);
    const [order, setOrder] = useState(HabitationOrderTypes.SEND_AT_DESC.id);

    const _statusFilter = useDebounce(status, 100);
    const _orderFilter = useDebounce(order, 100);

    const _fullNameFilter = useDebounce(fullName, 500);
    const _phoneNumberFilter = useDebounce(phoneNumber, 500);
    const _nationalCodeFilter = useDebounce(nationalCode, 500);
    const _startDateFilter = useDebounce(startDate, 500);

    const service = new PeriodService()


    useEffect(() => {
        page = 0
        getRequestListFromServer()
    }, [_fullNameFilter, _phoneNumberFilter, _nationalCodeFilter, _startDateFilter, _statusFilter, _orderFilter]);

    function getRequestListFromServer() {
        setIsLoading(true)
        service.getRequestListFromServer(
            periodId,
            _statusFilter,
            _orderFilter ? _orderFilter : HabitationOrderTypes.SEND_AT_DESC.id,
            _fullNameFilter,
            _phoneNumberFilter,
            _nationalCodeFilter,
            _startDateFilter,
            page,
            size
        ).then(response => {

            setRequestsList([])
            setPageCount(response.totalPage)
            setTotalItems(response.numberOfItems)


            response.data.map((item, index) => {
                setRequestsList(prevState => [
                    ...prevState,
                    createCollapsedTableRowData(
                        item.id,
                        <RequestDetails requestId={item.id} periodId={periodId}/>,
                        prepareRequestListRow(
                            (page * size) + index + 1,
                            item.id,
                            `${item.requesterFirstName} ${item.requesterLastName}`,
                            item.numberOfMen,
                            item.numberOfWomen,
                            item.status,
                            item.startDate,
                            item.endDate,
                            item.sendAt,
                            item.requesterNationalCode,
                            item.requesterProvince,
                            item.requesterCity,
                            item.requesterPhoneNumber,
                            item.document && item.document.downloadUrl && item.document.downloadUrl.length > 0 ?
                                item.document.downloadUrl : ""
                        )
                    )

                ])
            })
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    const [pageCount, setPageCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    const [requestsList, setRequestsList] = useState([])

    function prepareRequestListRow(
        number,
        id,
        teamLeader,
        menCapacity,
        womenCapacity,
        status,
        startDate,
        endDate,
        sendAt,
        requesterNationalCode,
        requesterProvince,
        requesterCity,
        requesterPhoneNumber,
        document,
    ) {
        let statusChip


        if (status === HabitationRequestStatusTypes.POSTED.id ||
            status === HabitationRequestStatusTypes.IN_AWAITING_LIST.id ||
            status === HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.id ||
            status === HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.id
        ) {
            statusChip =
                <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.warning}/>
        } else if (
            status === HabitationRequestStatusTypes.REJECTED.id ||
            status === HabitationRequestStatusTypes.CANCELLED.id ||
            status === HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id) {
            statusChip = <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.error}/>
        } else if (
            status === HabitationRequestStatusTypes.ACCEPTED.id ||
            status === HabitationRequestStatusTypes.REFERRED.id) {
            statusChip =
                <RaikoCustomSimpleChip title={getHabitationRequestStatus(status)} type={RaikoChipTypes.success}/>
        }


        return {
            number,
            id,
            teamLeader,
            menCapacity,
            womenCapacity,
            requesterPhoneNumber,
            status: statusChip,
            startDate: startDate ? convertUniversalDateToPersianDate(startDate) : "-",
            endDate: endDate ? convertUniversalDateToPersianDate(endDate) : "-",
            sendAt: sendAt ? convertUniversalDateToPersianDate(sendAt) : "-",
            requesterNationalCode,
            requesterProvince,
            requesterCity,
            access: document && document.length > 0 ? <TableOtherAccessContainer>
                    <img src={excel} width={32} height={32} alt={"excel"} onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        window.location.href = document
                        // new HttpClient().get(document).then(response => {
                        //     console.log("response", response)
                        //     doDownloadFile(response, teamLeader, "xlsx")
                        // }).catch(reason => {
                        //     console.log("reason", reason)
                        // })
                    }}/>

                </TableOtherAccessContainer>
                : <TableOtherAccessContainer>
                    <img className={css`filter: grayscale(1)`} src={excel} width={32} height={32} alt={"excel"}/>

                </TableOtherAccessContainer>,
        }

    }

    function handlePagination(newPage) {
        page = newPage
        getRequestListFromServer()
    }

    function handleDeleteAllFilters() {
        setPhoneNumber("")
        setNationalCode("")
        setStartDate("")
        setOrder(HabitationOrderTypes.SEND_AT_DESC.id)
        setStatus(HabitationRequestStatusTypes.ALL.id)
    }

    return (
        <>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"درخواست ها"}
                            amount={totalItems}

                        />
                        <RaikoTableSearchContainer
                            labelText={"نام و نام خانوادگی"}
                            hasFilter
                            setValue={setFullName}
                            value={fullName}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                phoneNumber.length > 0 || nationalCode.length > 0 || startDate.length > 0 ||
                                status.length > 0 && HabitationRequestStatusTypes.ALL.id !== status ||
                                order.length > 0 && HabitationOrderTypes.SEND_AT_DESC.id !== order
                            }
                        >
                            <RaikoGridOneColumn>
                                <RaikoCustomSelect
                                    labelText={"چینش"}
                                    setValue={setOrder}
                                    value={order}
                                    items={[
                                        raikoCustomSelectItemGenerator(HabitationOrderTypes.SEND_AT_DESC.id, HabitationOrderTypes.SEND_AT_DESC.title),
                                        raikoCustomSelectItemGenerator(HabitationOrderTypes.SEND_AT_ASC.id, HabitationOrderTypes.SEND_AT_ASC.title),
                                    ]}
                                />

                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    setValue={setStatus}
                                    value={status}
                                    items={[
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.ALL.id, HabitationRequestStatusTypes.ALL.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.ACCEPTED.id, HabitationRequestStatusTypes.ACCEPTED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.IN_AWAITING_LIST.id, HabitationRequestStatusTypes.IN_AWAITING_LIST.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.id, HabitationRequestStatusTypes.AWAITING_FOR_MANAGER_REVIEW.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.CANCELLED.id, HabitationRequestStatusTypes.CANCELLED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.POSTED.id, HabitationRequestStatusTypes.POSTED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.REJECTED.id, HabitationRequestStatusTypes.REJECTED.title),
                                        raikoCustomSelectItemGenerator(HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.id, HabitationRequestStatusTypes.AWAITING_FOR_DOCUMENT_UPLOAD.title),
                                    ]}
                                />
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumber}
                                    value={phoneNumber}/>

                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    setValue={setNationalCode}
                                    value={nationalCode}/>
                                <RaikoDatePicker
                                    label={"تاریخ شب اول"}
                                    date={startDate}
                                    setDate={setStartDate}
                                />
                            </RaikoGridOneColumn>
                        </RaikoTableSearchContainer>

                        <RaikoCollapsibleTable
                            data={requestsList}
                            header={requestsListTableHeader}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            isLoading={isLoading}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </>

    )
}
export default RequestsList;
const requestsListTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "teamLeader",
        label: "سرگروه",
    },
    {
        id: "requesterNationalCode",
        label: "کد ملی",
    },
    {
        id: "requesterPhoneNumber",
        label: "شماره همراه",
    },
    {
        id: "requesterProvince",
        label: "استان",
    },
    {
        id: "requesterCity",
        label: "شهر",
    },
    {
        id: "menCapacity",
        label: "تعداد آقا",
    },
    {
        id: "womenCapacity",
        label: "تعداد خانم",
    },
    {
        id: "startDate",
        label: "شب اول",
    },
    {
        id: "endDate",
        label: "شب آخر",
    },
    {
        id: "sendAt",
        label: "تاریخ ارسال",
    },
    {
        id: "access",
        label: "دسترسی ها",
    },
    {
        id: "status",
        label: "وضعیت"
    }
]